import { useEffect, useMemo, useState } from "react";
import { fetchShareHolder, resetShareHolders } from "./shareHoldersSlice";
import { useDispatch, useSelector } from "react-redux";
import API_ROUTES from "../../api-routes";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import apiService from "../../services/service";

const useShareHolders = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const shareHolders = useSelector((state) => state.shareHolders.shareHolders);
  const generalStatus = useSelector((state) => state.shareHolders.status);
  const ShareHolders = useMemo(
    () => shareHolders?.data || null,
    [shareHolders],
  );
  const [showRegistration, setShowRegistration] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [data, setData] = useState();
  const [ingredient, setIngredient] = useState("");
  const [editMsg, setEditMsg] = useState("");
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [shareLoading, setShareLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(ShareHolders)) {
      setData((prevData) => {
        if (JSON.stringify(prevData) !== JSON.stringify(ShareHolders)) {
          return ShareHolders;
        }
        return prevData;
      });
    } else {
      setData([]);
    }
  }, [ShareHolders]);

  useEffect(() => {
    const currentLocation = location.pathname.split("/")[3];
    if (generalStatus === "idle" && currentLocation === "share-holders") {
      dispatch(fetchShareHolder(id));
    }
  }, [dispatch, fetchShareHolder, generalStatus]);

  useEffect(() => {
    return () => {
      dispatch(resetShareHolders());
    };
  }, [dispatch, resetShareHolders]);

  const handleAddShareholderClick = () => {
    // setShowRegistration(true);
    navigate(`/entity/${id}/share-holders/add`);
  };

  const handleSave = async (formData) => {
    const shareHoldersData = {
      type: formData.type,
      name: formData.name,
      other_name: formData.other_name,
      preferred_name: formData.preferred_name,
      last_name: formData.last_name,
      legal_name: formData.legal_name,
      point_of_contact: formData.point_of_contact,
      email: formData.email,
      phone_code: formData.phone_code,
      phone: formData.phone,
      number_of_shares: formData.number_of_shares,
      share_percentage: formData.share_percentage,
    };

    try {
      const res = await apiService(API_ROUTES.ADD_SHARE_HOLDER, "POST", {
        body: JSON.stringify(shareHoldersData),
        replace: { id },
      });

      if (res.status) {
        dispatch(fetchShareHolder({ id, skipCache: true }));

        // const n=res?.data?.preferred_name?
        // `${res?.data?.preferred_name}`
        // :`${res?.data?.name} ${res?.data?.other_name} ${res?.data?.last_name || ""}`
        const n =
          res?.data?.preferred_name ||
          [res?.data?.name, res?.data?.other_name, res?.data?.last_name]
            .filter(Boolean)
            .join(" ");

        setSuccessMessage(
          `${n} ${res?.data?.legal_name} has been added as a shareholder. View Profile`,
        );
      } else {
        setSuccessMessage("Failed to create your shareholder");
      }
      setIsBtnLoading(false);
    } catch (error) {
      console.error("Error:", error);
      setIsBtnLoading(false);
    }

    setShowRegistration(false);
  };

  return {
    ShareHolders,
    showRegistration,
    setShowRegistration,
    handleAddShareholderClick,
    successMessage,
    setSuccessMessage,
    data,
    handleSave,
    ingredient,
    setIngredient,
    entityId: id,
    editMsg,
    setEditMsg,
    isBtnLoading,
    setIsBtnLoading,
    shareLoading,
    setShareLoading,
  };
};

export default useShareHolders;
